import { createLazyTypePolicy } from 'owa-lazy-cache-policy';

export const lazySampleResultTypePolicy = createLazyTypePolicy(
    () => import(/* webpackChunkName: "SampleResultTypePolicy"*/ './sampleResultTypePolicy'),
    m => m.sampleResultTypePolicy
);
